import tw, { styled } from 'twin.macro';
import { StyledLabel } from '@/components/Forms/components/FormGroup/FormGroup.styles';
import {
  FormContainer,
  Container,
  Content,
  Headline,
  IconContainer,
  Section,
  StyledWrapper,
  SuccessHeadline,
  SuccessContainer,
  SuccessIcon,
  InformationBlock,
} from '@/components/MidPageFormContainer/MidPageFormContainer.styles';
import { StyledError } from '../Forms/components/FormError/FormError.styles';
import { LegalTextWrap } from '../Forms/components/LegalText/LegalText.styles';
import { StyledInput } from '../../components/Forms/components/Input/Input.styles';
import { secondaryStyles } from '../../components/Link/Link.styles';
import { SubmitButton } from '../Forms/NewsletterForm/NewsletterForm.styles';
import {
  CheckedIcon as ChoiceCheckedIcon,
  UncheckedIcon as ChoiceUncheckedIcon,
  StyledLabel as ChoiceLabel,
} from '../Forms/components/ChoiceGroup/Choice.styles';

export const Wrapper = styled.div`
  ${tw`rounded-xl`}
  ${tw`h-full`}
  ${tw`px-2 py-6 md:px-6`}
  ${tw`table`}
  ${tw`text-left`}
  ${tw`flex flex-col justify-center`}
  ${tw`bg-secondary-s1`}

  /*
   * NewsletterForm component style overwrites start here.
   * These overwrites are necessary because the styles defined in NewsletterForm.styles.ts are 
   * the default styles for the NewsletterForm component (found in Storybook by searching for 'Newsletter').
   * We use the NewsletterForm component inside the CTACard, but we apply additonal styling.
   */
  ${FormContainer}, ${Container}, ${Section}, ${StyledWrapper}, ${SuccessContainer} {
    ${tw`!p-0`}
    ${tw`!m-0`}
    ${tw`block`}
    ${tw`bg-[transparent]`}
    ${tw`bg-none`}
  }

  ${StyledWrapper} {
    ${tw`lg:shadow-transparent`}
    ${tw`max-w-[none]`}
  }

  ${InformationBlock} {
    ${tw`items-start`}
  }

  ${IconContainer} {
    ${tw`mb-0`}
    & > svg {
      filter: brightness(0) invert(1);
      ${tw`max-h-[32px] max-w-[32px]`}
      ${tw`m-0`}
    }
  }

  ${SuccessIcon} {
    filter: brightness(0) invert(1);
    ${tw`max-h-[64px] max-w-[64px]`}
    ${tw`m-0`}
  }

  ${Headline}, ${SuccessHeadline} {
    ${tw`font-poppins font-semi-bold`}
    ${tw`text-heading-s text-left text-neutrals-n1`}
    ${tw`my-2`}
  }

  ${Content} {
    ${tw`font-inter`}
    ${tw`text-body-s text-left text-neutrals-n1`}
    ${tw`mb-[36px] sm:mb-[18px]`}
  }

  /* NewsletterForm component style overwrites end here. */

  ${ChoiceCheckedIcon}, ${ChoiceUncheckedIcon} {
    ${tw`text-neutrals-n1`}
  }

  ${ChoiceLabel} {
    ${tw`pt-[2px]`}
    ${tw`text-neutrals-n1`}
  }

  ${StyledLabel} {
    ${tw`font-inter font-medium text-mobile-heading-xxs`}
    ${tw`text-neutrals-n1`}
  }

  ${StyledInput} {
    ${tw`font-inter font-regular`}
  }

  ${SubmitButton} {
    ${secondaryStyles}
    // Because the SubmitButton is used in NewsletterForm as primary button and primary button has '::before' pseudo element, we need to override the before styles here.
    // We need to pass the padding-box to ensure the background gradient does not overflow the border radius.
    background: linear-gradient(to bottom, white, white) padding-box;
    ${tw`before:bg-transparent`}
    ${tw`hover:border-ui-colours-ui2`}
    ${tw`hover:before:bg-ui-colours-ui1 disabled:hover:cursor-not-allowed`}
    ${tw`disabled:before:bg-neutrals-n1 disabled:text-ui-colours-ui3 disabled:border-ui-colours-ui3`}
  }

  ${StyledError} {
    ${tw`inline-block`}
    ${tw`mt-[4px]`}
    ${tw`px-[4px] py-[1px]`}
    ${tw`bg-ui-colours-ui1`}
  }

  ${LegalTextWrap} {
    ${tw`text-neutrals-n1`}
    ${tw`text-pricing-tag-xs`}
    ${tw`tracking-normal`}
  }
`;
